<template>
  <b-col cols="12">
    <b-row class="row-offer-content" @click.stop>
      <b-col cols="12" md="3" class="col-content">
        <b-row>
          <b-col cols="12" class="d-block d-sm-none">Merchant Email / Message</b-col>
          <b-col cols="12">
            <b-row>
              <b-col cols="12">
                <strong>{{ purchaseOffer.userEmail }}</strong>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">{{ purchaseOffer.positionComment }}</b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="3" class="col-content">
        <b-row>
          <b-col cols="12">
            <b-row>
              <b-col cols="5" class="d-block d-sm-none">Demand Id</b-col>
              <b-col cols="7" sm="12">{{ purchaseOffer.demandId }}</b-col>
            </b-row>
            <b-row>
              <b-col cols="5" class="d-block d-sm-none">Variant</b-col>
              <b-col cols="7" sm="12">{{ purchaseOffer.variantKey }}</b-col>
            </b-row>
            <b-row>
              <b-col cols="5" class="d-block d-sm-none">Accepted Price</b-col>
              <b-col cols="7" sm="12">
                {{ purchaseOffer.acceptedPrice / 100 }}
                {{ purchaseOffer.acceptedCurrency }}
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="5" class="d-block d-sm-none">Accepted Date</b-col>
              <b-col cols="7" sm="12">

                {{ formattedTime(purchaseOffer.acceptedAt) }}
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="2" class="col-content">
        <b-row>
          <b-col cols="5" class="d-block d-sm-none">Accessible by</b-col>
          <b-col cols="7" sm="12">
            <span v-if="purchaseOffer.watchesToAccessDate">
              {{ formattedDate(purchaseOffer.watchesToAccessDate) }}
            </span>
            <span class="text-in-stock" v-if="!purchaseOffer.watchesToAccessDate">
              <span class="badge badge-success">In stock</span>
            </span>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="2" class="col-content">
        <b-row>
          <b-col cols="5" class="d-block d-sm-none">Offered</b-col>
          <b-col cols="7" md="12">
            <span :title="formattedTime(purchaseOffer.offeredAt)">{{ dateInWords(purchaseOffer.offeredAt) }} ago</span>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="2" class="col-content">
        <div class="btn btn-xs btn-warning btn-block" @click="openFailDialog()">
          Reactivate Demand
        </div>
      </b-col>
    </b-row>
    <admin-accepted-purchase-offer-fail-dialog
      @cancel="closeFailDialog()"
      @purchase-offer-failed="$emit('purchase-offer-failed')"
      v-if="showFailDialog"
      :purchase-offer="purchaseOffer"
    ></admin-accepted-purchase-offer-fail-dialog>
  </b-col>
</template>

<script>
import AdminAcceptedPurchaseOfferFailDialog from './AdminAcceptedPurchaseOfferFailDialog';
import { timeFormatMixin } from 'Mixins/timeFormatMixin';

export default {
  components: {
    AdminAcceptedPurchaseOfferFailDialog,
  },
  mixins: [timeFormatMixin],
  name: 'AdminAcceptedPurchaseOfferRow',
  props: ['purchaseOffer'],
  data: () => {
    return {
      error: {
        failPurchaseOffer: {
          isError: false,
          code: null,
          message: '',
        },
      },
      currentlySending: false,
      submittedSuccessfully: false,
      showFailDialog: false,
    };
  },
  methods: {
    openFailDialog() {
      this.showFailDialog = true;
    },
    closeFailDialog() {
      this.showFailDialog = false;
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.btn-xs {
  padding: 0.15rem 0.3rem;
  font-size: 0.85rem;
  line-height: 1.4;
  border-radius: 0.25rem;
}

.col-access-by-date {
  font-size: 0.9rem;
}

.col-content {
  padding-top: 4px;
  padding-bottom: 2px;
}

.text-in-stock {
  color: var(--success);
}

.row-offer-content {
  font-size: 0.8rem;
  margin-top: 3px;
  background-color: #eeeeee;
  border-left: 4px solid #bbb;
  &:hover,
  &:focus,
  &:active {
    background-color: #e3e3e3;
    border-left: 4px solid var(--primary);
  }

  @media all and(max-device-width: 576px) {
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
